import { render, staticRenderFns } from "./publishTiktok.vue?vue&type=template&id=1f22cbf6&scoped=true&"
import script from "./publishTiktok.vue?vue&type=script&lang=js&"
export * from "./publishTiktok.vue?vue&type=script&lang=js&"
import style0 from "./publishTiktok.vue?vue&type=style&index=0&id=1f22cbf6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f22cbf6",
  null
  
)

export default component.exports